"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Inner = exports.Wrapper = exports.Cell = exports.CONFIG = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var media_1 = require("../../../theme/media");
exports.CONFIG = {
    small: {
        columns: 4,
        gutters: 16,
        margins: '16px',
    },
    medium: {
        columns: 8,
        gutters: 24,
        margins: '40px',
    },
    large: {
        columns: 12,
        gutters: 32,
        margins: '40px',
    },
    xlarge: {
        columns: 12,
        gutters: 32,
        margins: 'auto',
        maxWidth: '1176px',
    },
};
exports.Cell = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  align-self: ", ";\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var alignSelf = _a.alignSelf;
    return alignSelf;
}, function (_a) {
    var _b = _a.order, order = _b === void 0 ? {} : _b;
    return Object.entries(exports.CONFIG).map(function (_a) {
        var _b = __read(_a, 1), bp = _b[0];
        return "\n        @media ".concat(media_1.breakpoints[bp] || '(min-width: 0px)', " {\n          order: ").concat(order[bp] || 'initial', ";\n      }");
    });
}, function (_a) {
    var _b = _a.span, span = _b === void 0 ? {} : _b;
    if (span === 'full') {
        return Object.keys(exports.CONFIG).map(function (bp) { return "\n          @media ".concat(media_1.breakpoints[bp] || '(min-width: 0px)', " {\n            grid-column-start: auto;\n            grid-column-end: span ").concat(exports.CONFIG[bp].columns, ";\n        }"); });
    }
    return Object.keys(span).map(function (key) {
        var _a;
        var bpSpan = span[key];
        var start;
        var end;
        var hasStart = false;
        if (bpSpan === 'full') {
            end = exports.CONFIG[key].columns;
        }
        else {
            ;
            _a = __read(Array.isArray(bpSpan) ? bpSpan : [undefined, bpSpan], 2), start = _a[0], end = _a[1];
            hasStart = typeof start === 'number';
        }
        return "@media ".concat(media_1.breakpoints[key] || '(min-width: 0px)', " {\n            grid-column-start: ").concat(start || 'auto', ";\n            grid-column-end: ").concat(hasStart ? '' : 'span ').concat(end + (hasStart ? 1 : 0), ";\n        }");
    });
});
var sliderCSS = "\noverflow-x: scroll;\npadding-top: 16px;\npadding-bottom: 16px;\nmargin-top: -16px;\nmargin-bottom: -16px;\n";
exports.Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n\n  padding-left: ", ";\n  padding-right: ", ";\n\n  @media ", " {\n    ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n\n  @media ", " {\n    ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n\n  @media ", " {\n    ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"], ["\n  ", ";\n\n  padding-left: ", ";\n  padding-right: ", ";\n\n  @media ", " {\n    ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n\n  @media ", " {\n    ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n\n  @media ", " {\n    ", ";\n\n    padding-left: ", ";\n    padding-right: ", ";\n  }\n"])), function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.small) ? sliderCSS : '');
}, exports.CONFIG.small.margins, exports.CONFIG.small.margins, media_1.breakpoints.medium, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.medium) ? sliderCSS : '');
}, exports.CONFIG.medium.margins, exports.CONFIG.medium.margins, media_1.breakpoints.large, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.large) ? sliderCSS : '');
}, exports.CONFIG.large.margins, exports.CONFIG.large.margins, media_1.breakpoints.xlarge, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.xlarge) ? sliderCSS : '');
}, exports.CONFIG.xlarge.margins, exports.CONFIG.xlarge.margins);
exports.Inner = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: grid;\n\n  grid-template-columns: repeat(\n    ", ",\n    ", "\n  );\n  grid-auto-columns: ", ";\n  grid-auto-flow: ", ";\n\n  column-gap: ", "px;\n  row-gap: ", "px;\n  align-items: ", ";\n  margin: 0 auto;\n  max-width: ", ";\n\n  ", "\n\n  &:after {\n    content: '';\n    display: ", ";\n    height: 1px;\n    width: 1px;\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(\n      ", ",\n      ", "\n    );\n    grid-auto-columns: ", ";\n    grid-auto-flow: ", ";\n\n    column-gap: ", "px;\n    row-gap: ", "px;\n\n    &:after {\n      display: ", ";\n      width: calc(\n        ", " -\n          ", "px\n      );\n    }\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(\n      ", ",\n      ", "\n    );\n    grid-auto-columns: ", ";\n    grid-auto-flow: ", ";\n\n    column-gap: ", "px;\n    row-gap: ", "px;\n\n    &:after {\n      display: ", ";\n      width: calc(\n        ", " - ", "px\n      );\n    }\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(\n      ", ",\n      ", "\n    );\n    grid-auto-columns: ", ";\n    grid-auto-flow: ", ";\n\n    column-gap: ", "px;\n    row-gap: ", "px;\n\n    &:after {\n      display: ", ";\n      width: calc(\n        ", " -\n          ", "px\n      );\n    }\n  }\n"], ["\n  display: grid;\n\n  grid-template-columns: repeat(\n    ", ",\n    ", "\n  );\n  grid-auto-columns: ", ";\n  grid-auto-flow: ", ";\n\n  column-gap: ", "px;\n  row-gap: ", "px;\n  align-items: ", ";\n  margin: 0 auto;\n  max-width: ", ";\n\n  ", "\n\n  &:after {\n    content: '';\n    display: ", ";\n    height: 1px;\n    width: 1px;\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(\n      ", ",\n      ", "\n    );\n    grid-auto-columns: ", ";\n    grid-auto-flow: ", ";\n\n    column-gap: ", "px;\n    row-gap: ", "px;\n\n    &:after {\n      display: ", ";\n      width: calc(\n        ", " -\n          ", "px\n      );\n    }\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(\n      ", ",\n      ", "\n    );\n    grid-auto-columns: ", ";\n    grid-auto-flow: ", ";\n\n    column-gap: ", "px;\n    row-gap: ", "px;\n\n    &:after {\n      display: ", ";\n      width: calc(\n        ", " - ", "px\n      );\n    }\n  }\n\n  @media ", " {\n    grid-template-columns: repeat(\n      ", ",\n      ", "\n    );\n    grid-auto-columns: ", ";\n    grid-auto-flow: ", ";\n\n    column-gap: ", "px;\n    row-gap: ", "px;\n\n    &:after {\n      display: ", ";\n      width: calc(\n        ", " -\n          ", "px\n      );\n    }\n  }\n"])), function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.small) ? "auto-fill" : exports.CONFIG.small.columns);
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.small) ? "".concat(100 / exports.CONFIG.small.columns, "%") : '1fr');
}, function (_a) {
    var $slider = _a.$slider;
    return ($slider === null || $slider === void 0 ? void 0 : $slider.small) ? "".concat(100 / exports.CONFIG.small.columns, "%") : '1fr';
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.small) ? "column" : '');
}, function (_a) {
    var $columnGap = _a.$columnGap;
    return ($columnGap === null || $columnGap === void 0 ? void 0 : $columnGap.small) || exports.CONFIG.small.gutters;
}, function (_a) {
    var $rowGap = _a.$rowGap;
    return ($rowGap === null || $rowGap === void 0 ? void 0 : $rowGap.small) || exports.CONFIG.small.gutters;
}, function (_a) {
    var $alignItems = _a.$alignItems;
    return $alignItems;
}, exports.CONFIG.xlarge.maxWidth, function (_a) {
    var $alignItems = _a.$alignItems;
    return $alignItems === 'stretch'
        ? "\n    > ".concat(exports.Cell, " > * {\n      height: 100%;\n    }\n  ")
        : '';
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.small) ? 'block' : 'none');
}, media_1.breakpoints.medium, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.medium) ? "auto-fill" : exports.CONFIG.medium.columns);
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.medium) ? "".concat(100 / exports.CONFIG.medium.columns, "%") : '1fr');
}, function (_a) {
    var $slider = _a.$slider;
    return ($slider === null || $slider === void 0 ? void 0 : $slider.medium) ? "".concat(100 / exports.CONFIG.medium.columns, "%") : '1fr';
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.medium) ? "column" : 'row');
}, function (_a) {
    var $columnGap = _a.$columnGap;
    return ($columnGap === null || $columnGap === void 0 ? void 0 : $columnGap.medium) || exports.CONFIG.medium.gutters;
}, function (_a) {
    var $rowGap = _a.$rowGap;
    return ($rowGap === null || $rowGap === void 0 ? void 0 : $rowGap.medium) || exports.CONFIG.medium.gutters;
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.medium) ? 'block' : 'none');
}, exports.CONFIG.medium.margins, function (_a) {
    var $columnGap = _a.$columnGap;
    return ($columnGap === null || $columnGap === void 0 ? void 0 : $columnGap.medium) || exports.CONFIG.medium.gutters;
}, media_1.breakpoints.large, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.large) ? "auto-fill" : exports.CONFIG.large.columns);
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.large) ? "".concat(100 / exports.CONFIG.large.columns, "%") : '1fr');
}, function (_a) {
    var $slider = _a.$slider;
    return ($slider === null || $slider === void 0 ? void 0 : $slider.large) ? "".concat(100 / exports.CONFIG.large.columns, "%") : '1fr';
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.large) ? "column" : 'row');
}, function (_a) {
    var $columnGap = _a.$columnGap;
    return ($columnGap === null || $columnGap === void 0 ? void 0 : $columnGap.large) || exports.CONFIG.large.gutters;
}, function (_a) {
    var $rowGap = _a.$rowGap;
    return ($rowGap === null || $rowGap === void 0 ? void 0 : $rowGap.large) || exports.CONFIG.large.gutters;
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.large) ? 'block' : 'none');
}, exports.CONFIG.large.margins, function (_a) {
    var $columnGap = _a.$columnGap;
    return ($columnGap === null || $columnGap === void 0 ? void 0 : $columnGap.large) || exports.CONFIG.large.gutters;
}, media_1.breakpoints.xlarge, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.xlarge) ? "auto-fill" : exports.CONFIG.xlarge.columns);
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.xlarge) ? "".concat(100 / exports.CONFIG.xlarge.columns, "%") : '1fr');
}, function (_a) {
    var $slider = _a.$slider;
    return ($slider === null || $slider === void 0 ? void 0 : $slider.xlarge) ? "".concat(100 / exports.CONFIG.xlarge.columns, "%") : '1fr';
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.xlarge) ? "column" : 'row');
}, function (_a) {
    var $columnGap = _a.$columnGap;
    return ($columnGap === null || $columnGap === void 0 ? void 0 : $columnGap.xlarge) || exports.CONFIG.xlarge.gutters;
}, function (_a) {
    var $rowGap = _a.$rowGap;
    return ($rowGap === null || $rowGap === void 0 ? void 0 : $rowGap.xlarge) || exports.CONFIG.xlarge.gutters;
}, function (_a) {
    var $slider = _a.$slider;
    return (($slider === null || $slider === void 0 ? void 0 : $slider.xlarge) ? 'block' : 'none');
}, exports.CONFIG.xlarge.margins, function (_a) {
    var $columnGap = _a.$columnGap;
    return ($columnGap === null || $columnGap === void 0 ? void 0 : $columnGap.xlarge) || exports.CONFIG.xlarge.gutters;
});
var templateObject_1, templateObject_2, templateObject_3;
